import React, { useEffect, useState } from 'react'
import PageTitle from '../../../jsx/layouts/PageTitle';
import ReactPaginate from 'react-paginate';
import { Button } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { getAllSportList } from '../../../services/commonApiService/CommonApiService';
import FilterNumber from '../../../jsx/components/FilterNumberDropDown/FilterNumber';
import SearchFilter from '../../../jsx/components/SearchFilter/SearchFilter';

const SportsList = () => {
    const [allSports, setAllSports] = useState([]);
    const [loading, setLoading] = useState(false);
    const [currentPage, setCurrentPage] = useState(1);
    const [perPage, setPerPage] = useState(10);
    const [searchValue, setSearchValue] = useState('');
    const navigate = useNavigate();

    useEffect(() => {
        const fetchSports = async () => {
            setLoading(true);
            try {
                const response = await getAllSportList();
                setAllSports(response?.data?.data || []);
            } catch (error) {
                console.error('Sports list error:', error);
            } finally {
                setLoading(false);
            }
        };
        fetchSports();
    }, []);

    const filteredSports = allSports.filter((sport) =>
        (sport?.sport_name || '').toLowerCase().includes(searchValue.toLowerCase())
    );
    const pageCount = Math.ceil(filteredSports.length / perPage);
    const pagedSports = filteredSports.slice((currentPage - 1) * perPage, currentPage * perPage);

    const handlePageChange = (event) => {
        setCurrentPage(event.selected + 1);
    };

    return (
        <>
            <PageTitle activeMenu="All Sports" motherMenu="Dashboard" />
            <div className="col-12">
                <div className="card filter-card-wrapper">
                    <div className="px-3 d-flex justify-content-between">
                        <div className="d-flex mt-3 mx-2">
                            <div>
                                <FilterNumber value={perPage} onChange={(val) => {
                                    setPerPage(val);
                                    setCurrentPage(1);
                                }} />
                            </div>
                            <div>
                                <SearchFilter searchValue={searchValue} setSearchValue={setSearchValue} setCurrentPage={setCurrentPage} />
                            </div>
                        </div>
                    </div>

                    <div className="card-body">
                        {loading ? (
                            <div className="text-center">
                                <div className="spinner-border text-primary" role="status">
                                    <span className="sr-only">Loading...</span>
                                </div>
                            </div>
                        ) : (
                            <div className="w-100 table-responsive">
                                <div id="example_wrapper" className="dataTables_wrapper">
                                    <table id="example" className="display w-100 dataTable">
                                        <thead>
                                            <tr>
                                                <th>SN</th>
                                                <th>Sport Name</th>
                                                <th>Action</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {pagedSports.length > 0 ? (
                                                pagedSports.map((sport, index) => {
                                                    const serialNumber = (currentPage - 1) * perPage + (index + 1);
                                                    return (
                                                        <tr key={sport.id}>
                                                            <td>{serialNumber}</td>
                                                            <td>{sport?.sport_name}</td>
                                                            <td>
                                                                <Button style={{ whiteSpace: 'nowrap' }} onClick={() => navigate(`/sport-detail/${sport?.sport_id}`)}> View </Button>
                                                            </td>
                                                        </tr>
                                                    );
                                                })
                                            ) : (
                                                <tr>
                                                    <td colSpan="3" className="text-center">Data is not available</td>
                                                </tr>
                                            )}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        )}
                    </div>
                </div>
                <ReactPaginate
                    nextLabel="next >"
                    onPageChange={handlePageChange}
                    pageRangeDisplayed={8}
                    marginPagesDisplayed={7}
                    pageCount={pageCount}
                    previousLabel="< previous"
                    pageClassName="page-item"
                    pageLinkClassName="page-link"
                    previousClassName="page-item"
                    previousLinkClassName="page-link"
                    nextClassName="page-item"
                    nextLinkClassName="page-link"
                    breakLabel="..."
                    breakClassName="page-item"
                    breakLinkClassName="page-link"
                    containerClassName="pagination d-flex flex-wrap"
                    activeClassName="active"
                    renderOnZeroPageCount={null}
                    forcePage={currentPage - 1}
                />
            </div>
        </>
    )
}

export default SportsList
